import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import { Dialog } from "@natera/material/lib/dialog";
import { Button } from "@natera/form";

import { ButtonNoShadow } from "@app/components/buttonNoShadow";

import "./insuranceConfirmationDialog.scss";
import { usePreBillHeapEvent } from "@app/preBill/hooks";
import { HEAP_EVENTS } from "@app/provider/types";

const messages = defineMessages({
  insuranceConfirmationDialogTitle: {
    id: "insuranceConfirmationDialogTitle",
    defaultMessage: "Continue with insurace?",
  },
  insuranceConfirmationDialogDesc: {
    id: "insuranceConfirmationDialogDesc",
    defaultMessage:
      "By confirming this, we will proceed with billing your insurance and your final bill may be much higher.",
  },
  insuranceConfirmationDialogYes: {
    id: "insuranceConfirmationDialogYes",
    defaultMessage: "Yes",
  },
  insuranceConfirmationDialogNo: {
    id: "insuranceConfirmationDialogNo",
    defaultMessage: "No",
  },
});

interface InsuranceConfirmationDialogProps {
  onClickYes: () => Promise<void>;
  onCloseDialog: () => void;
}

const InsuranceConfirmationDialog: FC<InsuranceConfirmationDialogProps> = ({
  onClickYes,
  onCloseDialog,
}) => {
  const intl = useIntl();
  const { trackPreBillHeapEvent } = usePreBillHeapEvent();

  const handleClickYes = async () => {
    try {
      trackPreBillHeapEvent({
        eventKey: HEAP_EVENTS.upp_pb_click_insurance_yes,
      });
      await onClickYes();
    } finally {
      onCloseDialog();
    }
  };

  const handleClickNo = () => {
    trackPreBillHeapEvent({ eventKey: HEAP_EVENTS.upp_pb_click_insurance_no });
    onCloseDialog();
  };

  return (
    <Dialog
      className="insurance-confirmation-dialog"
      title={intl.formatMessage(messages.insuranceConfirmationDialogTitle)}
      actions={
        <div className="insurance-confirmation-dialog__footer">
          <ButtonNoShadow raised onClick={handleClickYes}>
            {intl.formatMessage(messages.insuranceConfirmationDialogYes)}
          </ButtonNoShadow>
          <Button outlined onClick={handleClickNo}>
            {intl.formatMessage(messages.insuranceConfirmationDialogNo)}
          </Button>
        </div>
      }
      onClose={onCloseDialog}
      showCrossButton
    >
      <div className="insurance-confirmation-dialog__content">
        <span>
          {intl.formatMessage(messages.insuranceConfirmationDialogDesc)}
        </span>
      </div>
    </Dialog>
  );
};

export default InsuranceConfirmationDialog;
